export default "__VITE_ASSET__BFerH5m1__$_?react__"